import { useQuery } from "@tanstack/react-query";
import { apiRequest, type Envelope } from "../api/client";
import { readClaims } from "../auth/token";
import type { FloorImage, Game } from "./floor-logic";

// THE `floor-map.service.ts` ENDPOINTS, VERBATIM. ANGULAR LOADS BOTH ONCE PER APP (A ROOT
// SERVICE), SO THEY ARE CACHED FOR THE SESSION HERE TOO.
const user = () => String(readClaims()?.userId ?? "anonymous");

// `GetFloorMap`: THE FLOOR SVG, ITS SIZE AND THE MACHINE DOT RADIUS
export function useFloorImage() {
  return useQuery({
    queryKey: [user(), "floor", "svg"],
    queryFn: ({ signal }) => apiRequest<Envelope<FloorImage | null>>("/mf/floor/svg", { signal }).then((r) => r.data),
    staleTime: Infinity,
  });
}

// `loadAllGames`: TABLE GAMES THEN EGMS, FETCHED TOGETHER (`forkJoin`, SO EITHER FAILING FAILS BOTH)
export function useFloorGames() {
  return useQuery({
    queryKey: [user(), "floor", "games"],
    queryFn: async ({ signal }) => {
      const [tables, egms] = await Promise.all([
        apiRequest<Envelope<Game[] | null>>("/ht/table-games", { signal }),
        apiRequest<Envelope<Game[] | null>>("/ht/egms", { signal }),
      ]);
      return [...(tables.data ?? []), ...(egms.data ?? [])];
    },
    staleTime: Infinity,
  });
}
